import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GreennessSurveyTypes } from '@inyova/models';

@Component({
  selector: 'app-reporting-dialog-greenness',
  templateUrl: './reporting-dialog-greenness.component.html',
  styleUrls: ['./reporting-dialog-greenness.component.scss'],
  standalone: false
})
export class ReportingDialogGreennessComponent {
  @Input() appLocation: string;
  @Input() dialogType: 'survey' | 'notification' = 'survey';
  @Input() showSurvey: GreennessSurveyTypes;
  @Input() success!: boolean;
  @Output() dismissSurvey: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() submitSurvey: EventEmitter<{ greenness_score?: number; annual_income?: string; net_worth?: string }> = new EventEmitter<{
    greenness_score?: number;
    annual_income?: string;
    net_worth?: string;
  }>();

  onSurveySubmit(data: { score?: number; income?: string; worth?: string }) {
    this.submitSurvey.emit({
      ...(data.score && { greenness_score: data.score }),
      ...(data.income && { annual_income: data.income }),
      ...(data.worth && { net_worth: data.worth })
    });
  }
}
